(function () {
  var root = document.querySelector('[data-peptide-guide]');
  if (!root) return;

  var input = root.querySelector('[data-guide-search]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-guide-card]'));
  var countEl = root.querySelector('[data-guide-count]');
  var emptyEl = root.querySelector('[data-guide-empty]');

  function filter() {
    var term = input.value.trim().toLowerCase();
    var visible = 0;

    cards.forEach(function (card) {
      var name = card.getAttribute('data-guide-card') || '';
      var match = name.indexOf(term) !== -1;
      card.style.display = match ? '' : 'none';
      if (match) visible++;
    });

    countEl.textContent = visible + (visible === 1 ? ' item' : ' items');
    emptyEl.classList.toggle('show', visible === 0);
  }

  input.addEventListener('input', filter);
  filter();

  cards.forEach(function (card) {
    var toggle = card.querySelector('[data-guide-toggle]');
    var body = card.querySelector('[data-guide-body]');
    if (!toggle || !body) return;

    toggle.addEventListener('click', function () {
      var isOpen = card.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        body.style.maxHeight = body.scrollHeight + 'px';
      } else {
        body.style.maxHeight = null;
      }
    });
  });
})();
